export default [
    {
        "login": "Heisenberg27074",
        "id": 65938639,
        "node_id": "MDQ6VXNlcjY1OTM4NjM5",
        "avatar_url": "https://avatars.githubusercontent.com/u/65938639?v=4",
        "gravatar_id": "",
        "url": "https://api.github.com/users/Heisenberg27074",
        "html_url": "https://github.com/Heisenberg27074",
        "followers_url": "https://api.github.com/users/Heisenberg27074/followers",
        "following_url": "https://api.github.com/users/Heisenberg27074/following{/other_user}",
        "gists_url": "https://api.github.com/users/Heisenberg27074/gists{/gist_id}",
        "starred_url": "https://api.github.com/users/Heisenberg27074/starred{/owner}{/repo}",
        "subscriptions_url": "https://api.github.com/users/Heisenberg27074/subscriptions",
        "organizations_url": "https://api.github.com/users/Heisenberg27074/orgs",
        "repos_url": "https://api.github.com/users/Heisenberg27074/repos",
        "events_url": "https://api.github.com/users/Heisenberg27074/events{/privacy}",
        "received_events_url": "https://api.github.com/users/Heisenberg27074/received_events",
        "type": "User",
        "site_admin": false
    },
    {
        "login": "rajatinclude",
        "id": 66425204,
        "node_id": "MDQ6VXNlcjY2NDI1MjA0",
        "avatar_url": "https://avatars.githubusercontent.com/u/66425204?v=4",
        "gravatar_id": "",
        "url": "https://api.github.com/users/rajatinclude",
        "html_url": "https://github.com/rajatinclude",
        "followers_url": "https://api.github.com/users/rajatinclude/followers",
        "following_url": "https://api.github.com/users/rajatinclude/following{/other_user}",
        "gists_url": "https://api.github.com/users/rajatinclude/gists{/gist_id}",
        "starred_url": "https://api.github.com/users/rajatinclude/starred{/owner}{/repo}",
        "subscriptions_url": "https://api.github.com/users/rajatinclude/subscriptions",
        "organizations_url": "https://api.github.com/users/rajatinclude/orgs",
        "repos_url": "https://api.github.com/users/rajatinclude/repos",
        "events_url": "https://api.github.com/users/rajatinclude/events{/privacy}",
        "received_events_url": "https://api.github.com/users/rajatinclude/received_events",
        "type": "User",
        "site_admin": false
    },
    {
        "login": "vivolscute",
        "id": 55041874,
        "node_id": "MDQ6VXNlcjU1MDQxODc0",
        "avatar_url": "https://avatars.githubusercontent.com/u/55041874?v=4",
        "gravatar_id": "",
        "url": "https://api.github.com/users/vivolscute",
        "html_url": "https://github.com/vivolscute",
        "followers_url": "https://api.github.com/users/vivolscute/followers",
        "following_url": "https://api.github.com/users/vivolscute/following{/other_user}",
        "gists_url": "https://api.github.com/users/vivolscute/gists{/gist_id}",
        "starred_url": "https://api.github.com/users/vivolscute/starred{/owner}{/repo}",
        "subscriptions_url": "https://api.github.com/users/vivolscute/subscriptions",
        "organizations_url": "https://api.github.com/users/vivolscute/orgs",
        "repos_url": "https://api.github.com/users/vivolscute/repos",
        "events_url": "https://api.github.com/users/vivolscute/events{/privacy}",
        "received_events_url": "https://api.github.com/users/vivolscute/received_events",
        "type": "User",
        "site_admin": false
    },
    {
        "login": "includerajat",
        "id": 78809406,
        "node_id": "MDQ6VXNlcjc4ODA5NDA2",
        "avatar_url": "https://avatars.githubusercontent.com/u/78809406?v=4",
        "gravatar_id": "",
        "url": "https://api.github.com/users/includerajat",
        "html_url": "https://github.com/includerajat",
        "followers_url": "https://api.github.com/users/includerajat/followers",
        "following_url": "https://api.github.com/users/includerajat/following{/other_user}",
        "gists_url": "https://api.github.com/users/includerajat/gists{/gist_id}",
        "starred_url": "https://api.github.com/users/includerajat/starred{/owner}{/repo}",
        "subscriptions_url": "https://api.github.com/users/includerajat/subscriptions",
        "organizations_url": "https://api.github.com/users/includerajat/orgs",
        "repos_url": "https://api.github.com/users/includerajat/repos",
        "events_url": "https://api.github.com/users/includerajat/events{/privacy}",
        "received_events_url": "https://api.github.com/users/includerajat/received_events",
        "type": "User",
        "site_admin": false
    }
]